import React from 'react'
import {Icon} from 'antd'

export default(props)=>{
  const {name,icon} = props
  return (
    <React.Fragment>
      {
        typeof(icon)==='string'&&icon.length>0&&
        <Icon type={icon} className="mr-2" />
      }
      {name}
    </React.Fragment>
  )
}
